export default __webpack_public_path__ + "static/media/chat6.b5f5d299.png";